import styled from "styled-components";
import { colors, containerMaxWidth } from "../../common/styles/variables";
import { mobileRange, tabletRange } from "../../common/styles/breakpoints";

export const PrivacyPage = styled.div`
  min-height: 700px;
  color: ${colors.sherpa_blue};
  position: relative;
  background: ${colors.white};
  & .body-container {
    max-width: ${containerMaxWidth};
    padding:0;
    @media ${mobileRange}{
    }
    @media ${tabletRange} {
      margin-top:-60px
    }
  }
  .privacy-policy-content {
    color: ${colors.davy_grey};
    line-height: 1.78;
    letter-spacing: -0.23px;
    text-align: left;
    font-size: 16px;
    padding-bottom: 20px;
    @media ${tabletRange} {
      font-size: 14px;
      line-height: 1.57;
      letter-spacing: -0.18px;
    }
    @media ${mobileRange} {
      font-size: 16px;
      line-height: 1.57;
      letter-spacing: -0.18px;
    }
    .contact-us-link, a {
      color: ${colors.bondi_blue};
      cursor: pointer;
      text-decoration: none;
    }
  }
  .contact-us {
    font-size: 20px;
    line-height: 1.28;
    margin-bottom: 0;
    padding-bottom: 15px;
    @media ${tabletRange} {
      font-size: 22px;
      padding-bottom: 13px;
      line-height: 1.45;
    }
    @media ${mobileRange} {
      font-size: 18px;
    }
  }
`;

export const HeadingContent = styled.h1`
  background: ${colors.light_grey};
  font-size: 30px;
  margin-bottom: 0;
  @media ${mobileRange}{
    width: 100%;
    font-size: 25px;
    padding-top: 45px;
  }
  & .container {
    padding: 62px 100px 62px 84px;
    max-width: ${containerMaxWidth};
    font-size: 25px;
    @media ${mobileRange}{
      padding: 55px 0 120px;
      text-align: center;
    }
    @media ${tabletRange}{
      padding: 30px 0 90px 84px;
    }
  }
`;

export const ConditionSection = styled.div`
  width:100%;
  padding: 20px 96px 35px;
  background: ${colors.white};
  box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.1);
  margin-top: -23px;

  @media ${mobileRange}{
    padding: 94px 17px 25px ;
  }
  @media ${tabletRange}{
    padding: 12px 64px 20px 84px;
  }
`;

export const ImageSection = styled.div`
float: right;
width: 33%;
margin-top: -145px;

@media ${mobileRange} {
  width: 100%;
  text-align: center;
}

@media ${tabletRange} {
  width: 41%;
  margin-top: -87px;
}

img {
  width: 336px;
  @media ${mobileRange} {
    width: 205px;
  }
  @media ${tabletRange}{
    width:205px
  }
}
`;

export const PrivacyContent = styled.div`
  padding-bottom: 5px;
  @media ${tabletRange} {
    padding-bottom: 0;
  }
  @media ${mobileRange} {
    padding-bottom: 0;
  }
`;

export const SectionTitle = styled.div`
  font-size: 20px;
  line-height: 1.28;
  letter-spacing: -0.33px;
  color: ${colors.sherpa_blue};
  padding-bottom: 15px;
  @media ${tabletRange} {
    font-size: 22px;
    line-height: 1.45;
    letter-spacing: -0.29px;
    padding-bottom: 13px;
  }
  @media ${mobileRange} {
    font-size: 18px;
    line-height: 1.45;
    letter-spacing: -0.29px;
  }
`;

export const ContentTitle = styled.div`
  font-size: 20px;
  letter-spacing: -0.29px;
  color: ${colors.mine_shaft};
  margin-bottom: 5px;
  @media ${tabletRange} {
    font-size: 14px;
    line-height: 1.57;
    letter-spacing: -0.18px;
    margin-bottom: 0;
  }
  @media ${mobileRange} {
    font-size: 16px;
    line-height: 1.57;
    letter-spacing: -0.18px;
    margin-bottom: 0;
  }
`;

